import React, { useEffect, useState } from "react";
import { HiStar, HiX, HiCheckCircle } from "react-icons/hi";
import FeedbackSection from "../FeedbackSection/FeedbackSection";

const DetailsModal = ({ isOpen, onClose, service }) => {
    const [show, setShow] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setShow(true);
            setTimeout(() => setVisible(true), 10);
            document.body.style.overflow = 'hidden';
        } else {
            setVisible(false);
            setTimeout(() => setShow(false), 300);
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen]);

    if (!show || !service) return null;

    return (
        <div 
            className={`fixed inset-0 z-[9999] flex items-center justify-center p-4 md:p-8 transition-all duration-300 ease-out ${visible ? "opacity-100 backdrop-blur-md bg-black/40" : "opacity-0 backdrop-blur-0 bg-transparent"}`}
            onClick={onClose}
        >
            <div 
                className={`relative w-full max-w-4xl max-h-[90vh] overflow-hidden rounded-[2.5rem] bg-white shadow-2xl transition-all duration-500 ease-out flex flex-col md:flex-row ${visible ? "scale-100 translate-y-0" : "scale-95 translate-y-12"}`}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Close Button */}
                <button 
                    onClick={onClose}
                    className="absolute top-6 right-6 z-20 w-12 h-12 rounded-full glass flex items-center justify-center text-foreground hover:bg-red-500 hover:text-white transition-all shadow-lg"
                >
                    <HiX size={24} />
                </button>

                {/* Left Side: Image & High-level Info */}
                <div className="md:w-5/12 relative h-64 md:h-auto overflow-hidden">
                    <img 
                        src={service.img} 
                        alt={service.name} 
                        className="w-full h-full object-cover" 
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-8">
                        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/90 text-white font-black text-[10px] uppercase tracking-widest w-fit mb-4">
                            Premium Choice
                        </span>
                        <h2 className="text-3xl font-heading font-black text-white">{service.name}</h2>
                        <div className="flex items-center gap-2 mt-2">
                            <div className="flex text-accent">
                                {[1,2,3,4,5].map(s => <HiStar key={s} size={16} />)}
                            </div>
                            <span className="text-white/80 text-xs font-bold font-heading">({service.rating})</span>
                        </div>
                    </div>
                </div>

                {/* Right Side: Details & Feedback */}
                <div className="md:w-7/12 overflow-y-auto p-8 md:p-12 space-y-8 custom-scrollbar bg-white">
                    <div className="flex items-center justify-between">
                        <div className="space-y-1">
                            <p className="text-[10px] font-black uppercase tracking-widest text-muted-foreground">Investment</p>
                            <div className="flex items-end gap-3">
                                <span className="text-4xl font-black text-primary">₹{service.discountedPrice}</span>
                                <span className="text-lg font-bold text-muted-foreground line-through opacity-50 mb-1">₹{service.originalPrice}</span>
                            </div>
                        </div>
                        <div className="text-right">
                             <div className="px-4 py-2 rounded-2xl bg-green-50 text-green-600 border border-green-100 flex items-center gap-2">
                                <HiCheckCircle size={20} />
                                <span className="text-xs font-black uppercase tracking-widest">Available Now</span>
                             </div>
                        </div>
                    </div>

                    <div className="space-y-6">
                        <div className="flex items-center gap-4">
                            <div className="h-px flex-grow bg-border"></div>
                            <h3 className="text-xs font-black uppercase tracking-[0.3em] text-muted-foreground">What's Included</h3>
                            <div className="h-px flex-grow bg-border"></div>
                        </div>
                        
                        <ul className="grid sm:grid-cols-2 gap-4">
                            {(Array.isArray(service.description) ? service.description : [service.description]).map((item, index) => (
                                <li key={index} className="flex items-start gap-3 p-4 rounded-2xl bg-secondary/50 group hover:bg-white hover:shadow-xl hover:shadow-primary/5 transition-all duration-300">
                                    <HiCheckCircle className="text-primary mt-0.5 shrink-0" size={18} />
                                    <span className="text-sm font-medium text-foreground/80 leading-relaxed">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="pt-8 space-y-6">
                        <div className="flex items-center gap-4">
                            <div className="h-px flex-grow bg-border"></div>
                            <h3 className="text-xs font-black uppercase tracking-[0.3em] text-muted-foreground">Customer Insights</h3>
                            <div className="h-px flex-grow bg-border"></div>
                        </div>
                        <FeedbackSection />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailsModal;

